import React from "react";
import Modal from "react-bootstrap/Modal";
import {guideList} from "../../utils/policyUtils";

const Modals = (props:any) => {
  // console.log(props,'/[Modals.tsx------------------------->]');
  const {show,navigate,alertType,imgSrc,userInfo,onClose,message,children} = props;
  
  const onHandleHome = ()=> {
    navigate('/');
    window.location.reload();
  }
  
  // console.log(`123123123`)
  // console.log(props)
  
  const textRef = () => {
    
    if(alertType === `default`) {
      return (
        <>
          <div className={`txt_box text-center`}>
            <p className={`h3`}>{message || children}</p>
          </div>
          <button onClick={()=>onClose(false)} className={`btn w-[100%] block btn-primary`}>확인</button>
        </>
      )
    }
    
    if(alertType === `phone_verification`) {
      return (
        <>
          <div className={`txt_box text-center`}>
            <p className={`h3`}>{userInfo?.name}님 환영합니다.</p>
            <p className={`h3`}>이름 등 개인 정보는 마이페이지에서 수정할 수 있어요.</p>
          </div>
          <button onClick={onHandleHome} className={`btn w-[100%] block btn-primary`}>확인</button>
        </>
      )
    }
    if(alertType === `using_user`) {
      return (
        <>
          <div className={`txt_box text-center`}>
            <p className={`h3`}>이미 사용중인 상품이 있어</p>
            <p className={`h3`}>새로운 상품을 구매할 수 없어요.</p>
          </div>
          <div className={`flex justify-between gap-[24px]`}>
            <button onClick={()=>navigate('/mypage')} className={`btn w-[50%] block btn-primary`}>
              이용중인 상품 보기
            </button>
            <button onClick={()=>onClose(false)} className={`btn w-[50%] block btn-primary`}>
              닫기
            </button>
          </div>
        </>
      )
    }
    if(alertType === `same_user`) {
      return (
        <>
          <div className={`txt_box text-center`}>
            <p className={`h3`}>{message}</p>
          </div>
          <button onClick={() => {
            navigate(`/`);
            window.location.reload();
          }} className={`btn w-[100%] block btn-primary`}>확인</button>
        </>
      )
    }
    if(alertType === `guide`) {
      return (
        <>
        
        </>
      )
    }
    
    if(alertType === `form_load`) {
      return (
        <>
          <div className={`txt_box text-center`}>
            <p className={`h3`}>
              페이지에서 벗어나면<br/>작성중인 내용이 삭제됩니다.
            </p>
          </div>
          <div className={`flex justify-between gap-[24px]`}>
            <button onClick={() => onClose(false)} className={`btn w-[50%] block btn-primary`}>
              계속쓰기
            </button>
            <button onClick={() => navigate('/cs_center')} className={`btn w-[50%] block btn-danger`}>
              작성중인 내용 삭제
            </button>
          </div>
        </>
      )
    }
    
  }
  
  return (
    <>
      <Modal show={show} animation={false} centered className={`al_phone ${alertType}`}>
        {imgSrc && (
          <img src={imgSrc} alt={``} className={`m-auto modal_img`}/>
        )}
        {textRef()}
        
      </Modal>
    </>
  )
}
export default Modals